import styled from 'styled-components';

import { devices } from '../../utilities/responsive';

export const ContainerGrid = styled.div`
    display: grid;
    grid-template-columns: 75% calc(25% - 2vw);
    gap: 40px;
    align-items: flex-start;

    @media ${devices.tabletLandscape} {
        grid-template-columns: 100%;
    }
`

export const Articles = styled.div`
    width: 100%;

    @media ${devices.tabletLandscape} {
        order: 2;
    }
`;
export const MainArticlesGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
    grid-template-rows: 1fr auto;
    column-gap: 40px;
    margin: 0 0 80px 0;

    @media ${devices.tabletLandscape} {
        grid-template-columns: 100%;
        gap: 80px;
    }
`

export const SecondaryArticlesGrid = styled.div`
    margin: 30px 0;
    display: grid;
    grid-template-columns: 1fr;
    border-top: 1px solid var(--light-grey);

    .card__secondary {
        width: 100%;
        padding: 40px 0;
        border-bottom: 1px solid var(--light-grey);
    }
`

export const Filters = styled.div`
    position: -webkit-sticky;
    position: sticky;
    top: 100px;
    width: 100%;

    @media ${devices.tabletLandscape} {
        position: initial;
        order: 1;
    }
`
export const WelcomeText = styled.div`
p {
        font-weight: 700;
    }
`

